import { z } from 'zod';
export var providerType = z.enum(['test-provider', 'przelewy24', 'pragma', 'liberis']);
export var companyType = z.enum([
    'jednoosobowa',
    'zoo',
    'spolka_partnerska',
    'spoldzielnia',
    'osoba',
    'komandytowoakcyjna',
    'komandytowa',
    'jawna',
    'fundacja',
    'cywilna',
    'akcyjna',
    'stowarzyszenie',
]);
export var identityDocumentType = z.enum(['idCard', 'passport', 'residenceCard', 'other']);
export var documentType = z.enum([
    'idCard',
    'polishPassport',
    'test-provider-contract',
    'p24-contract',
    'pragma',
    'other',
    'liberis',
]);
export var userType = z.enum([
    'user',
    'limit',
    'limit2',
    'ksiegowy',
    'void', // It's a user type without specific privileges schema in p24
    'super',
    'posrednik',
    'handlowiec',
]);
export var loanStage = z.union([
    z.literal(0),
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
    z.literal(9),
]);
export var loanProviderRequest = z.enum([
    'gotNotification',
    'requested',
    'requestFailed',
    'notificationFailed',
    'editRequested',
    'gotEditNotification',
    'notificationEditFailed',
    'smsRequested',
    'loanSigned',
]);
export var apiResponseType = z.enum([
    'LOAN',
    'LOAN_EDIT',
    'SMS_CODE',
    'SMS_CODE_VERIFY',
    'AGREEMENT_ADD',
    'AGREEMENT_EDIT',
    'IFRAME_MERCHANT_SUMMARY',
    'LOAN_DETAILS',
    'PROVIDER_CONFIG',
    'TRANSFER_DETAILS',
    'TRANSFER_CONFIRM',
    'LOAN_CANCEL',
    'P24_AGGREGATED_DATA',
    'BLACKLIST_ADD',
    'BLACKLIST_EDIT',
    'BLACKLIST_DETAILS',
    'MESSAGE_SEND',
    'EVENT_CLICK',
    'LOAN_OFFER',
    'LOAN_DOCUMENT',
    'SMS_CODE_RESET',
    'LOAN_SIGN',
    'LOAN_SIGN_VERIFY',
    'REPORT',
    'DISCOUNT_VALIDATE',
]);
export var agreementResponseType = z.enum([
    apiResponseType.enum.AGREEMENT_ADD,
    apiResponseType.enum.AGREEMENT_EDIT,
]);
export var loanResponseStatus = z.enum([
    'AGREED',
    'REJECTED',
    'NEW',
    'TERMINATED',
    'OPEN',
    'SIGNED',
    'CANCELED',
    'EXPIRED',
    'CLOSED',
    'PENDING',
    'DONE',
]);
export var loanResponseConfigParametersNames = z.enum([
    'name_surname',
    'pesel',
    'documentId',
    'phone',
    'mail',
    'taxId',
    'bankAccount',
    'companyName',
]);
export var accountsType = z.array(z.union([z.number(), z.string()]));
export var hashType = z.enum(['FINANCING-OBJECT', 'WIDGET-OBJECT']);
export var marketingAgreementType = z.enum(['email', 'sms', 'tel']);
export var messageTemplateType = z.enum([
    'PUSH_1',
    'PUSH_2',
    'PUSH_3',
    'PUSH_4',
    'PUSH_5',
    'CONTACT_FORM',
]);
export var activityType = z.enum([
    'FAQ',
    'TRANSFERS_REPORT',
    'DASHBOARD_NEW_LOAN',
    'DASHBOARD_CONTINUE_LOAN',
    'WIDGET_NEW_LOAN',
    'WIDGET_CONTINUE_LOAN',
    'OFFERS_VIEW',
    'MORE_OFFERS',
    'OFFER_CHOSEN',
    'LIBERIS_CONSENTS',
    'LIBERIS_COMPANY_DETAILS',
    'LIBERIS_PERSONS_DETAILS',
    'LIBERIS_SUMMARY_ACCEPT',
    'LIBERIS_AGREEMENT_SIGN',
    'PRAGMA_SUMMARY_ACCEPT',
    'PRAGMA_AGREEMENT_SIGN',
]);
export var flowType = z.enum([
    'multiprovider',
    'defaultPragma',
    'defaultLiberis',
    'onlyPragma',
    'onlyLiberis',
]);
var rawAgreements = [
    'representative',
    'loanTerms',
    'pragmaTerms',
    'bikbig',
    'marketing',
    'payProDataProcessing',
    'pragmaGoDataProcessing',
    'bureau',
    'professionalContract',
];
export var agreementsNames = z.enum(rawAgreements);
var prefixedAgreements = rawAgreements.map(function (name) { return "pragmaAgreements.".concat(name); });
export var prefixedAgreementsNames = z.enum(prefixedAgreements);
export var liberisAgreementsNames = z.enum([
    'agreements.bureau',
    'agreements.liberisMarketing',
    'agreements.payProToLiberisData',
    'agreements.liberisDataToPayPro',
]);
export var reportFileExtensionType = z.enum(['pdf', 'csv', 'xlsx']);
export var promotionCodeErrorType = z.enum([
    'INVALID_CODE',
    'INACTIVE',
    'INVALID_OFFER',
    'CODE_NOT_YET_ENABLED',
    'CODE_EXPIRED',
    'USED',
    'LOAN_AMOUNT_TO_HIGH',
    'LOAN_AMOUNT_TO_LOW',
    'FIRST_LOAN',
    'NEXT_LOAN',
    'PRICING_TOO_LOW',
]);
